import { useEffect, useState } from "react";

/**
 * Return an array of booleans for whether or not a query matches
 * @param mediaQueryLists
 */
const getMatches = (mediaQueryLists: MediaQueryList[]) => {
  const matches = mediaQueryLists.map((mql) => mql.matches);
  return matches;
};

/**
 * Given a list of media queries, useMedia returns an array of booleans
 * for whether the current screen size matches the media query
 */
const useMedia = (...queries: string[]) => {
  // Array containing a MediaQueryList for each query
  const mediaQueryLists =
    typeof window === "undefined"
      ? []
      : queries.map((q) => window.matchMedia(q));

  const mediaQueryString = mediaQueryLists.join();

  // State and setter for the list of matches
  const [matches, setMatches] = useState(() => getMatches(mediaQueryLists));

  useEffect(() => {
    // Get the current list of media query matches
    const handler = () => setMatches(getMatches(mediaQueryLists));
    // Set a listener for each media query with above handler as callback.
    mediaQueryLists.forEach((mql) => mql.addListener(handler));
    // Remove listeners on cleanup
    return () => mediaQueryLists.forEach((mql) => mql.removeListener(handler));
    // We use a stringified version of the `mediaQueryLists` to give the useEffect
    // dependency a stable identity
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaQueryString]);

  return matches;
};

export default useMedia;
